import { CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { useParallaxRef } from '@/utils/parallax';

export default function DocumentsTab() {
  const subtitleRef = useParallaxRef({ speed: -0.10, axis: 'y', maxTranslate: 32 });

  return (
    <>
      <CardHeader className="text-center pb-12">
        <CardTitle className="text-4xl md:text-5xl font-bold mb-6">Documents</CardTitle>
        <CardDescription ref={subtitleRef as any} className="text-xl md:text-2xl text-foreground/70 mb-20">
          Download invoices, receipts, and agreements for your domains.
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-6 pt-4">
        <div className="space-y-6">
          <div>
            <h3 className="text-sm font-medium mb-3">Invoices & Receipts</h3>
            <div className="border rounded-lg p-4">
              <p className="text-sm text-muted-foreground">No documents yet.</p>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-medium mb-3">Agreements & Contracts</h3>
            <div className="border rounded-lg p-4">
              <p className="text-sm text-muted-foreground">No documents yet.</p>
            </div>
          </div>
        </div>
      </CardContent>
    </>
  );
}

